export interface VisualComponentDef
{
    name:string;
    title:string;
    tip:string;
    definedBy:string;

    getReactClassCtor():Promise<React.ComponentClass<any>>
}

export const VisualComponentDefs:VisualComponentDef[] = [
    {
        name: 'Box',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/box/Box.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "box" */ '@mintdata/mint-components/components/box/Box');
            return module.Box;
        }
    },
    {
        name: 'SplitView',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/splitView/SplitView.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "splitView" */ '@mintdata/mint-components/components/splitView/SplitView');
            return module.SplitView;
        }
    },
    {
        name: 'Table',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/table/Table.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "table" */ '@mintdata/mint-components/components/table/Table');
            return module.Table;
        }
    },
    {
        name: 'ButtonGroup',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/ButtonGroup.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "buttonGroup" */ '@mintdata/mint-components/components/buttonGroup/ButtonGroup');
            return module.ButtonGroup;
        }
    },
    {
        name: 'DateRangeInput',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/DateRangeInput.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "dateRangeInput" */ '@mintdata/mint-components/components/dateRangeInput/DateRangeInput');
            return module.DateRangeInput;
        }
    },
    {
        name: 'Navigation',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/Navigation.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "navigation" */ '@mintdata/mint-components/components/navigation/Navigation');
            return module.Navigation;
        }
    },
    {
        name: 'Picklist',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/Picklist.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "picklist" */ '@mintdata/mint-components/components/picklist/Picklist');
            return module.Picklist;
        }
    },
    {
        name: 'RangeSlider',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/RangeSlider.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "rangeSlider" */ '@mintdata/mint-components/components/rangeSlider/RangeSlider');
            return module.RangeSlider;
        }
    },
    {
        name: 'Slider',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/Slider.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "slider" */ '@mintdata/mint-components/components/slider/Slider');
            return module.Slider;
        }
    },
    {
        name: 'Button',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/button/Button.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "button" */ '@mintdata/mint-components/components/button/Button');
            return module.Button;
        }
    },
    {
        name: 'Calendar',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/calendar/Calendar.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "calendar" */ '@mintdata/mint-components/components/calendar/Calendar');
            return module.Calendar;
        }
    },
    {
        name: 'Chart',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/chart/Chart.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "chart" */ '@mintdata/mint-components/components/chart/Chart');
            return module.Chart;
        }
    },
    {
        name: 'Checkbox',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/checkbox/Checkbox.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "checkbox" */ '@mintdata/mint-components/components/checkbox/Checkbox');
            return module.Checkbox;
        }
    },
    {
        name: 'DateInput',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/dateInput/DateInput.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "dateInput" */ '@mintdata/mint-components/components/dateInput/DateInput');
            return module.DateInput;
        }
    },
    {
        name: 'Dropdown',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/dropdown/Dropdown.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "dropdown" */ '@mintdata/mint-components/components/dropdown/Dropdown');
            return module.Dropdown;
        }
    },
    {
        name: 'FilePicker',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/filePicker/FilePicker.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "filePicker" */ '@mintdata/mint-components/components/filePicker/FilePicker');
            return module.FilePicker;
        }
    },
    {
        name: 'Heatmap',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/heatmap/Heatmap.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "heatmap" */ '@mintdata/mint-components/components/heatmap/Heatmap');
            return module.Heatmap;
        }
    },
    {
        name: 'Icon',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/icon/Icon.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "icon" */ '@mintdata/mint-components/components/icon/Icon');
            return module.Icon;
        }
    },
    {
        name: 'Iframe',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/iframe/Iframe.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "iframe" */ '@mintdata/mint-components/components/iframe/Iframe');
            return module.Iframe;
        }
    },
    {
        name: 'Image',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/image/Image.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "image" */ '@mintdata/mint-components/components/image/Image');
            return module.Image;
        }
    },
    {
        name: 'Label',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/label/Label.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "label" */ '@mintdata/mint-components/components/label/Label');
            return module.Label;
        }
    },
    {
        name: 'Map',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/map/Map.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "map" */ '@mintdata/mint-components/components/map/Map');
            return module.Map;
        }
    },
    {
        name: 'NumericInput',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/numericInput/NumericInput.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "numericInput" */ '@mintdata/mint-components/components/numericInput/NumericInput');
            return module.NumericInput;
        }
    },
    {
        name: 'Paragraph',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/paragraph/Paragraph.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "paragraph" */ '@mintdata/mint-components/components/paragraph/Paragraph');
            return module.Paragraph;
        }
    },
    {
        name: 'PopoverContainer',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/popoverContainer/PopoverContainer.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "popoverContainer" */ '@mintdata/mint-components/components/popoverContainer/PopoverContainer');
            return module.PopoverContainer;
        }
    },
    {
        name: 'ProgressBar',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/progressBar/ProgressBar.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "progressBar" */ '@mintdata/mint-components/components/progressBar/ProgressBar');
            return module.ProgressBar;
        }
    },
    {
        name: 'RadioButtonGroup',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/radioButtonGroup/RadioButtonGroup.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "radioButtonGroup" */ '@mintdata/mint-components/components/radioButtonGroup/RadioButtonGroup');
            return module.RadioButtonGroup;
        }
    },
    {
        name: 'RichTextEditor',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/richTextEditor/RichTextEditor.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "richTextEditor" */ '@mintdata/mint-components/components/richTextEditor/RichTextEditor');
            return module.RichTextEditor;
        }
    },
    {
        name: 'SoundPlayer',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/soundPlayer/SoundPlayer.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "soundPlayer" */ '@mintdata/mint-components/components/soundPlayer/SoundPlayer');
            return module.SoundPlayer;
        }
    },
    {
        name: 'SQLEditor',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/SQLEditor/SQLEditor.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "sqlEditor" */ '@mintdata/mint-components/components/SQLEditor/SQLEditor');
            return module.SQLEditor;
        }
    },
    {
        name: 'Switch',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/switch/Switch.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "switch" */ '@mintdata/mint-components/components/switch/Switch');
            return module.Switch;
        }
    },
    {
        name: 'Tabs',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/tabs/Tabs.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "tabs" */ '@mintdata/mint-components/components/tabs/Tabs');
            return module.Tabs;
        }
    },
    {
        name: 'Text',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/text/Text.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "text" */ '@mintdata/mint-components/components/text/Text');
            return module.Text;
        }
    },
    {
        name: 'TextArea',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/textArea/TextArea.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "textArea" */ '@mintdata/mint-components/components/textArea/TextArea');
            return module.TextArea;
        }
    },
    {
        name: 'TextInput',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/textInput/TextInput.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "textInput" */ '@mintdata/mint-components/components/textInput/TextInput');
            return module.TextInput;
        }
    },
    {
        name: 'TimeInput',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/timeInput/TimeInput.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "timeInput" */ '@mintdata/mint-components/components/timeInput/TimeInput');
            return module.TimeInput;
        }
    },
    {
        name: 'ToggleButtonSet',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/toggleButtonSet/ToggleButtonSet.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "toggleButtonSet" */ '@mintdata/mint-components/components/toggleButtonSet/ToggleButtonSet');
            return module.ToggleButtonSet;
        }
    },
    {
        name: 'TooltipDecorator',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/tooltipDecorator/TooltipDecorator.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "tooltipDecorator" */ '@mintdata/mint-components/components/tooltipDecorator/TooltipDecorator');
            return module.TooltipDecorator;
        }
    },
    {
        name: 'VideoPlayer',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/videoPlayer/VideoPlayer.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "videoPlayer" */ '@mintdata/mint-components/components/videoPlayer/VideoPlayer');
            return module.VideoPlayer;
        }
    },
    {
        name: 'Twilio',
        title: '',
        tip: '',
        definedBy: '@mintdata/mint-components/components/twilio/Twilio.js',
        async getReactClassCtor()
        {
            const module = await import(/* webpackChunkName: "twilio" */ '@mintdata/mint-components/components/twilio/Twilio');
            return module.TwilioComponent;
        }
    }
];
